/**
 * @flow
 * @relayHash fa0242bb8ae6cd6d60f9e73c375b811f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddOrderYieldInput = {|
  orderId: string,
  itemId: string,
  orderedQuantity: number,
  unitPrice?: ?number,
  discountPercent?: ?number,
|};
export type AddOrderYieldMutationVariables = {|
  input: AddOrderYieldInput
|};
export type AddOrderYieldMutationResponse = {|
  +addOrderYield: {|
    +orderYieldEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +order: {|
          +id: string,
          +subtotal: ?number,
          +discountAmount: ?number,
          +taxAmount: ?number,
          +totalAmount: ?number,
          +yields: {|
            +edges: ?$ReadOnlyArray<?{|
              +node: {|
                +id: string
              |}
            |}>
          |},
        |},
        +orderedQuantity: number,
        +unitPrice: ?number,
        +discountPercent: ?number,
        +lineTotal: ?number,
        +item: {|
          +id: string,
          +itemNumber: string,
          +name: string,
          +partNumber: ?string,
          +description: ?string,
        |},
      |},
    |}
  |}
|};
export type AddOrderYieldMutation = {|
  variables: AddOrderYieldMutationVariables,
  response: AddOrderYieldMutationResponse,
|};
*/


/*
mutation AddOrderYieldMutation(
  $input: AddOrderYieldInput!
) {
  addOrderYield(input: $input) {
    orderYieldEdge {
      cursor
      node {
        id
        order {
          id
          subtotal
          discountAmount
          taxAmount
          totalAmount
          yields {
            edges {
              node {
                id
              }
            }
          }
        }
        orderedQuantity
        unitPrice
        discountPercent
        lineTotal
        item {
          id
          itemNumber
          name
          partNumber
          description
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddOrderYieldInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addOrderYield",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddOrderYieldPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "orderYieldEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderYieldEdge",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "OrderYield",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "subtotal",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "discountAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "taxAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OrderYieldConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrderYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "OrderYield",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "orderedQuantity",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "unitPrice",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountPercent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lineTotal",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "partNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddOrderYieldMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddOrderYieldMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddOrderYieldMutation",
    "id": null,
    "text": "mutation AddOrderYieldMutation(\n  $input: AddOrderYieldInput!\n) {\n  addOrderYield(input: $input) {\n    orderYieldEdge {\n      cursor\n      node {\n        id\n        order {\n          id\n          subtotal\n          discountAmount\n          taxAmount\n          totalAmount\n          yields {\n            edges {\n              node {\n                id\n              }\n            }\n          }\n        }\n        orderedQuantity\n        unitPrice\n        discountPercent\n        lineTotal\n        item {\n          id\n          itemNumber\n          name\n          partNumber\n          description\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ae21d313935bdc1fe6d7b196f619b862';
module.exports = node;
